import { Team } from '@ori/testid-generator';

export const APPLICATION_NAME = 'mini-shopping-bag';
export const TEAM = Team.Checkout;
